import { BaseService } from "./baseService";
import { SurgeryTypeDto, SurgeryTypeFormData } from "../types/surgeryType"; // Βεβαιώσου ότι το path είναι σωστό

class SurgeryTypeService extends BaseService<SurgeryTypeDto, SurgeryTypeFormData> {
  constructor() {
    super("/SurgeryType");
  }
}
export const surgeryTypeService = new SurgeryTypeService();
